import React, { useCallback, useEffect, useState } from "react";
import logo from "../assets/images/homePage/Piku_Token_Set.png";
import back from "../assets/images/homePage/coin_background.png";
import arrow from "../assets/images/homePage/chevron-right.svg";
import usdc from "../assets/images/homePage/USDC.svg";
import usdt from "../assets/images/homePage/USDT.svg";
import dai from "../assets/images/homePage/DAI.svg";
import Calque from "../assets/images/homePage/Swissquote.svg";
import ave from "../assets/images/homePage/capital.svg";
import seearrow from "../assets/images/homePage/home_right_arrow.png";
import cross from "../assets/images/homePage/x-mark.svg";
import Select from "react-select";
import eth from "../assets/images/overview/ETH.svg";
import Chart from "../components/Overview/Chart";
import MintModal from "../components/Overview/MintModal";
import RedeemModal from "../components/Overview/RedeemModal";
import DatePicker from "react-datepicker";
import useTranslation from "../Languages/Translation";
import SynapsModal from "../components/KYC/SynapsModal";
import { useWeb3Modal, useWeb3ModalAccount, useWeb3ModalProvider } from "@web3modal/ethers/react";
import { ethers } from "ethers";
import {
  addTokenToMetaMask,
  getLockedPikuPrice,
  getPikuBalance,
  getPikuPrice, getTotalPikuSupply,
  getUsdcBalance, isUserWhiteListed, requestPermissions
} from "../Service/Web3/Web3Service";
import { piku_contract_constants } from "../Service/Web3/Web3constants";
import { useWeb3Context } from "../Service/Web3/Web3Context";

function Overview() {

  const { walletProvider } = useWeb3ModalProvider()
  const { address, isConnected } = useWeb3ModalAccount()

  const [tab, settab] = useState("1");
  const [Identity, setIdentity] = useState(false);
  const [MintModel, setMintModel] = useState(false);
  const [RedeemModel, setRedeemModel] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [piku_price, setPikuPrice] = useState(0);
  const [total_supply, setTotalSupply] = useState(0);
  const [myBalance, setMyBalance] = useState({});
  const [isWhiteListed, setIsWhiteListed] = useState(false);
  const { refresh } = useWeb3Context()

  const fetchData = async () => {

    const provider = new ethers.BrowserProvider(walletProvider);
    const signer = await provider.getSigner();
    const piku_price = await getPikuPrice(signer);
    const total_supply = await getTotalPikuSupply(signer);
    const address = await signer.getAddress();
    const total_supply_float_2_dig = parseFloat(total_supply).toFixed(2);
    const isUserPassKyc = await isUserWhiteListed(signer);
    setIsWhiteListed(isUserPassKyc);
    setTotalSupply(total_supply_float_2_dig);
    setPikuPrice(piku_price);

    let usdc_balance = await getUsdcBalance(signer, address);
    let piku_balance = await getPikuBalance(signer, address);
    let locked_balance = await getLockedPikuPrice(signer);
    setMyBalance({
      usdc: parseFloat(usdc_balance).toFixed(2),
      piku: parseFloat(piku_balance).toFixed(2),
      piku_price: parseFloat(piku_price * piku_balance).toFixed(2),
      locked_balance: locked_balance,
    });
  };
  useEffect(() => {

    if (address && isConnected) {
      fetchData();
    }
  }, [address, isConnected, refresh]);


  const tablelist = [
    {
      image: usdc,
      title: "USDC",
      code: "On Chain",
      percent: "20%",
    },
    {
      image: dai,
      title: "DAI",
      code: "On Chain",
      percent: "15%",
    },
    {
      image: usdt,
      title: "USDT",
      code: "On Chain",
      percent: "15%",
    },
    {
      image: Calque,
      title: "US Treasury Swissquote",
      code: "On Chain",
      percent: "15%",
    },
    {
      image: ave,
      title: "US Treasury Capital Union",
      code: "On Chain",
      percent: "5%",
    },
  ];

  const options = [
    { value: "India", label: "India" },
    { value: "Turkey", label: "Turkey" },
    { value: "USA", label: "USA" },
  ];

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "#1a1a1a",
      border: "none !important",
      borderRadius: "8px !important",
      padding: "12px",
      fontFamily: "Aeonic_normal",
      outline: "none",
    }),
    option: (styles) => {
      return {
        ...styles,
        backgroundColor: "#2f2f2f",
        color: "#fff",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "#484848",
        },
      };
    },
    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        color: "#484848",
        fontFamily: "Aeonic_normal",
      };
    },
  };

  const [FirstName, setFirstName] = useState("");
  const [LastName, setLastName] = useState("");
  const [PasspotNo, setPassportNo] = useState("");

  // const user = localStorage.getItem("user");
  const kycdetail = localStorage.getItem("kycdetail");

  // on Kyc Form Submit

  const onSubmitKyc = (e) => {
    e?.preventDefault();
    const Data = {
      FirstName: FirstName,
      LastName: LastName,
      PasspotNo: PasspotNo,
    };

    if (address) {
      localStorage.setItem("kycdetail", JSON.stringify(Data));

      closeModal();
      setFirstName("");
      setLastName("");
      setPassportNo("");
    }
  };

  const clearData = () => {
    setFirstName("");
    setLastName("");
    setPassportNo("");
    setStartDate(new Date());
    closeModal();
  };

  const translation = useTranslation();

  const [chartfilter, setchartfilter] = useState("1");
  const importToMetamask = async () => {
    try {
      console.log("importToMetamask");
      const provider = new ethers.BrowserProvider(walletProvider);
      const tokenAddress = piku_contract_constants.address; // Token kontrat adresi
      const tokenSymbol = 'PK'; // Token sembolü
      const tokenDecimals = 18; // Token ondalık basamakları
      const tokenImage = 'https://i.ibb.co/m5BC35n/Group-67993.png'; // Token görüntü URL'si

      const wasAdded = await provider.send('wallet_watchAsset', {
        type: 'ERC20', // Token türü
        options: {
          address: tokenAddress,
          symbol: tokenSymbol,
          decimals: tokenDecimals,
          image: tokenImage,
        },
      });

      if (wasAdded) {
        console.log('Token MetaMask\'a eklendi');
      } else {
        console.log('Token MetaMask\'a eklenemedi');
      }
    } catch (error) {
      if (error.code === 4001) {
        // Kullanıcı token ekleme isteğini reddetti
        console.error('Kullanıcı token ekleme isteğini reddetti.');
      } else {
        console.error('Bir hata oluştu:', error);
      }
    }
  };



  // kyc modal
  const openModal = () => {
    setIdentity(true);
    document.body.style.overflow = "hidden"; // Disable scrolling
  };

  const closeModal = () => {
    setIdentity(false);
    document.body.style.overflow = "auto"; // Enable scrolling
  };

  // mint modal
  const openMintModel = () => {
    setMintModel(true);
    document.body.style.overflow = "hidden"; // Disable scrolling
  };

  const closeMintModel = () => {
    setMintModel(false);
    document.body.style.overflow = "auto"; // Enable scrolling
  };

  // Redeem modal
  const openRedeemModel = () => {
    setRedeemModel(true);
    document.body.style.overflow = "hidden"; // Disable scrolling
  };

  const closeRedeemModel = () => {
    setRedeemModel(false);
    document.body.style.overflow = "auto"; // Enable scrolling
  };


  return (
    <div className=" main_container ">
      {!isWhiteListed ? (
        //  if Kyc not Complete
        <div
          className={
            "bg-white mt-[120px] rounded-[24px] p-[2px] relative overflow-hidden"
          }
        >
          <div className="flex flex-col md:flex-row md:items-center justify-between border border-black rounded-[24px] p-[24px] md:p-[32px]">
            <img src={back} alt="back" className=" hidden md:block absolute right-0"></img>
            <div>
              <p className="text-black text-[12px] md:text-[18px] aeonik_normal">
                STABLECOIN VALUE
              </p>
              <div className=" flex items-center pt-[8px] md:pt-[12px] pb-[4px]">
                <img src={logo} alt="logo"></img>
                <p className="text-[20px] md:text-[32px] pl-[12px] pr-[8px] aeonik_bold text-black">
                  1 PIKU = ${piku_price}
                </p>
              </div>
              <p className="text-black text-[16px] aeonik_normal mb-[24px] md:mb-0">
                Backing Yield 7% + PikuG Airdrop
              </p>
            </div>
            {/*<a*/}
            {/*   onClick={() => openModal()}*/}
            {/*   className="rounded-[150px] cursor-pointer flex items-center text-[18px] aeonik_medium text-black justify-between border border-black z-10 bg-white px-[23px] py-[9px]"*/}
            {/* >*/}
            {/*   {translation.CompleteKYC}*/}
            {/*   <img src={arrow} alt="arrow" className="pl-[12px]"></img>*/}
            {/* </a>*/}
            <SynapsModal handleOpenExternal={() => onSubmitKyc()} />
          </div>
        </div>
      ) : (
        //  After Kyc Complete
        <div className=" mt-[80px] lg:mt-[120px]">
          <div className=" flex flex-col lg:flex-row lg:items-center justify-between">
            <p className="text-white text-[24px] lg:text-[32px] aeonik_medium">Piku</p>
            <div className="mt-[12px] lg:mt-0 flex flex-col lg:flex-row lg:items-center">
              <div className=" flex items-center">
                <a
                  onClick={() => openMintModel()}
                  className="cursor-pointer text-black rounded-[150px] py-[10px] lg:py-[12px] w-[50%] lg:w-auto text-center lg:px-[58px] lg:text-[18px] aeonik_medium bg-sky block"
                >
                  {translation.Mint}
                </a>
                <a
                  onClick={() => openRedeemModel()}
                  className="cursor-pointer text-black rounded-[150px] ml-[12px] py-[10px] lg:py-[12px] w-[50%] lg:w-auto text-center lg:px-[41px] lg:text-[18px] aeonik_medium bg-[#FF7733] block"
                >
                  {translation.Redeem}
                </a>
              </div>

              <a
                className="cursor-pointer text-[#FF7733] min-w-full lg:min-w-[150px] lg:max-w-[150px] rounded-[150px] mt-[12px] lg:mt-0 lg:ml-[12px] py-[10px] lg:py-[5px] px-2 w-[50%] lg:w-auto text-center  lg:text-[14px] aeonik_medium bg-[#1f110a] block"
              >
                Pending Transactions
              </a>
            </div>
          </div>
          <div className=" grid grid-cols-10 mt-[24px]">
            <div className="col-span-12 lg:col-span-2 p-[11px] lg:p-[24px] border border-[#222] rounded-t-[12px] lg:rounded-tr-[0px] lg:rounded-tl-[12px]">
              <p className=" text-[14px] aeonik_medium text-[#808586]">
                Last Price
              </p>
              <p className=" lg:text-[24px] aeonik_normal pt-[12px] text-white">
                ${piku_price}
              </p>
            </div>
            <div className="col-span-12 lg:col-span-2 p-[11px] lg:p-[24px] border border-[#222]">

              <p className=" text-[14px] aeonik_medium text-[#808586]">
                Yield Info
              </p>
              <p className=" text-[14px] aeonik_normal pt-[12px] text-white">
                Backing Yield 7% + PikuG Airdrop
              </p>
            </div>
            <div className="col-span-12 lg:col-span-2 p-[11px] lg:p-[24px] border border-[#222]">

              <p className=" text-[14px] aeonik_medium text-[#808586]">
                TVL (Total value locked)
              </p>
              <p className=" lg:text-[24px] aeonik_normal pt-[12px] text-white">
                ${myBalance.locked_balance}
              </p>
            </div>
            <div className="col-span-12 lg:col-span-2 p-[11px] lg:p-[24px] border border-[#222]">

              <p className=" text-[14px] aeonik_medium text-[#808586]">
                Network
              </p>
              <div className="flex items-center pt-[12px]">
                <img
                  src={eth}
                  alt="logo"
                  className="h-[20px] w-atuo object-contain mr-[12px]"
                />
                <p className="lg:text-[24px] text-white aeonik_normal">Ethereum</p>
              </div>
            </div>
            <div className="col-span-12 lg:col-span-2 p-[11px] lg:p-[24px] border border-[#222] rounded-b-[12px] lg:rounded-b-[0px] lg:rounded-tr-[12px]">
              <p className=" text-[14px] aeonik_medium text-[#808586]">
                Total Supply
              </p>
              <p className=" lg:text-[24px] aeonik_normal pt-[12px] text-white">
                {total_supply}
              </p>
              <p className=" text-[14px] aeonik_medium cursor-pointer pt-[12px] text-sky" onClick={async () => await importToMetamask()}>
                Import token to Metamask
              </p>
            </div>
          </div>
          <div className=" bg-[#030f11] p-[24px] border border-[#222] rounded-bl-[12px] rounded-br-[12px]">
            <p className=" text-[20px] text-white aeonik_medium mb-[32px]">
              My holdings
            </p>
            <table className=" w-full">
              <thead className=" bg-[#111c1f] ">
                <tr>
                  <th className=" text-[#818889] rounded-l-[6px] py-[5px] pl-[12px] text-left text-[14px] aeonik_medium">
                    Name
                  </th>
                  <th className=" text-[#818889] py-[5px] text-left text-[14px] aeonik_medium">
                    <p className="">Total Amount</p>
                  </th>
                  <th className=" text-[#818889] py-[5px] rounded-r-[6px] text-left text-[14px] aeonik_medium">
                    Active Value
                  </th>
                </tr>
              </thead>
              <tbody>

                <tr>
                  <td className=" min-w-[100px] align-top	pt-[20px] pb-[16px] border-b border-[#222222]">
                    <div className=" flex items-center pl-[12px]">
                      <img src={logo} alt="pikulogo" className=" w-[20px] mr-[4px]"></img>
                      <p className=" text-white aeonik_normal text-[14px] lg:text-[16px]">PIKU</p>
                    </div>
                  </td>
                  <td className=" text-white text-[16px] align-top	pt-[20px] pb-[16px] border-b border-[#222222]">
                    <div className="text-[14px] lg:text-[16px]">{myBalance.piku} <span className=" text-[#818889]">PIKU</span></div>
                  </td>
                  <td className="align-top	pt-[20px] pb-[16px] border-b border-[#222222]">
                    <p className="text-[14px] lg:text-[16px] text-white aeonik_normal">${myBalance.piku_price}</p>
                  </td>
                </tr>
                <tr>
                  <td className=" min-w-[100px] align-top	pt-[20px] pb-[16px]">
                    <div className=" flex items-center pl-[12px]">
                      <img src={usdc} alt="usdc" className=" w-[20px] mr-[4px]"></img>
                      <p className="text-[14px] lg:text-[16px] text-white aeonik_normal">USDC</p>
                    </div>
                  </td>
                  <td className=" text-white text-[16px] align-top	pt-[20px] pb-[16px]">
                    <div className="text-[14px] lg:text-[16px]">{Number(myBalance.usdc / piku_price).toFixed(2)} <span className=" text-[#818889]">PIKU</span></div>
                  </td>
                  <td className="align-top	pt-[20px] pb-[16px]">
                    <p className="text-[14px] lg:text-[16px] text-white aeonik_normal">${myBalance.usdc}</p>
                  </td>
                </tr>
                {/* <tr>
                  <td className=" min-w-[150px] align-top	">
                    <div className=" flex items-center justify-between">
                      <p className=" text-white aeonik_normal">USDC</p>
                      <p className=" text-white aeonik_normal">{myBalance.usdc}</p>
                    </div>
                  </td>
                  <td className=" text-white lg:text-[24px] align-top	">
                    <div className="mx-[64px] aeonik_normal"> ${myBalance.piku_price}</div>
                  </td>
                  <td className="align-top	">
                    <p className=" text-white aeonik_normal">{myBalance.piku} PIKU</p>
                    <p className=" text-[14px] aeonik_medium cursor-pointer pt-[12px] text-sky" onClick={async () => await importToMetamask()}>
                      Import token to Metamask
                    </p>
                  </td>
                </tr> */}
              </tbody>
            </table>
          </div>
          <div className=" mt-[48px] relative">
            <Chart pikuPrice={piku_price} />
            <p className=" text-[14px] text-sky bg-[#051d21] rounded-[24px] aeonik_normal py-[4px] px-[8px] inline-block absolute left-[100px] top-[33px]">
              +3.2%
            </p>
            <ul className=" flex justify-between lg:justify-end w-full items-center absolute right-0 top-[80px] lg:top-[30px]">
              <li
                onClick={() => setchartfilter("1")}
                className={`${chartfilter === "1"
                  ? "bg-[#222222] text-white"
                  : "text-[#808181]"
                  }  cursor-pointer px-[8px] py-[6px] rounded-[8px] text-[14px] aeonik_normal`}
              >
                1D
              </li>
              <li
                onClick={() => setchartfilter("2")}
                className={`${chartfilter === "2"
                  ? "bg-[#222222] text-white"
                  : "text-[#808181]"
                  } px-[8px] py-[6px] rounded-[8px] text-[14px] cursor-pointer aeonik_normal mx-[12px]`}
              >
                1M
              </li>
              <li
                onClick={() => setchartfilter("3")}
                className={`${chartfilter === "3"
                  ? "bg-[#222222] text-white"
                  : "text-[#808181]"
                  } px-[8px] py-[6px] rounded-[8px] text-[14px] cursor-pointer aeonik_normal`}
              >
                3M
              </li>
              <li
                onClick={() => setchartfilter("4")}
                className={`${chartfilter === "4"
                  ? "bg-[#222222] text-white"
                  : "text-[#808181]"
                  } px-[8px] py-[6px] rounded-[8px] text-[14px] cursor-pointer aeonik_normal mx-[12px]`}
              >
                6M
              </li>
              <li
                onClick={() => setchartfilter("5")}
                className={`${chartfilter === "5"
                  ? "bg-[#222222] text-white"
                  : "text-[#808181]"
                  } px-[8px] py-[6px] rounded-[8px] text-[14px] cursor-pointer aeonik_normal`}
              >
                YTD
              </li>
              <li
                onClick={() => setchartfilter("6")}
                className={`${chartfilter === "6"
                  ? "bg-[#222222] text-white"
                  : "text-[#808181]"
                  } px-[8px] py-[6px] rounded-[8px] text-[14px] cursor-pointer aeonik_normal ml-[12px]`}
              >
                All
              </li>
            </ul>
          </div>
        </div>
      )
      }

      {/* table section  */}

      <div className="pt-[30px] md:pt-[46px] flex items-center justify-between">
        <p className="text-[#fff] aeonik_medium text-[24px] md:text-[32px]">
          {translation.ReserveBackingDistribution}
        </p>
        <div className=" flex items-center rounded-[10px] bg-[#1a1c1d] p-[4px]">
          <div
            onClick={() => settab("1")}
            className={`${tab === "1" && "bg-[#fff]"
              } rounded-[6px] py-[3px] cursor-pointer px-[6px]`}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.75 6.75H20.25M3.75 12H20.25M3.75 17.25H20.25"
                stroke={`${tab === "1" ? "#010304" : "#fff"}`}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div
            onClick={() => settab("2")}
            className={`${tab === "2" && "bg-[#fff]"
              } rounded-[6px] py-[5px] px-[8px] cursor-pointer`}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.875 11.25C1.875 7.45304 4.95304 4.375 8.75 4.375C9.09518 4.375 9.375 4.65482 9.375 5V10.625H15C15.3452 10.625 15.625 10.9048 15.625 11.25C15.625 15.047 12.547 18.125 8.75 18.125C4.95304 18.125 1.875 15.047 1.875 11.25Z"
                fill={`${tab === "2" ? "#010304" : "#fff"}`}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.625 2.5C10.625 2.15482 10.9048 1.875 11.25 1.875C15.047 1.875 18.125 4.95304 18.125 8.75C18.125 9.09518 17.8452 9.375 17.5 9.375H11.25C10.9048 9.375 10.625 9.09518 10.625 8.75V2.5Z"
                fill={`${tab === "2" ? "#010304" : "#fff"}`}
              />
            </svg>
          </div>
        </div>
      </div>

      <table className="w-full my-[32px]">
        <thead className="bg-[#1c2023] h-[30px] ">
          <tr>
            <th className="pl-[10px] md:pl-[30px] rounded-l-[8px] text-left aeonik_medium text-[11px] md:text-[14px] text-[#8d8f91]">
              RATE
            </th>
            <th className=" text-left aeonik_medium pl-[5px] text-[11px] md:text-[14px] text-[#8d8f91]">
              CRYPTO
            </th>
            <th className=" text-left rounded-r-[8px] pr-[10px] aeonik_medium text-[11px] md:text-[14px] text-[#8d8f91]">
              TRANSACTIONS
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className=" pt-[16px]"></td>
          </tr>
          {tablelist?.map((m, i) => (
            <tr className="border border-b-[#1a1c1d]" key={i}>
              <td className="text-white text-[14px] md:text-[18px] pl-[10px] md:pl-[30px] py-[16px] aeonik_bold">
                {m.percent}
              </td>
              <td className=" py-[16px] pl-[5px]">
                <div className="flex items-center">
                  <img src={m.image} alt="usdc"></img>
                  <p className="text-white text-[14px] md:text-[18px] pl-[6px] ms:pl-[8px] aeonik_normal">
                    {m.title}
                  </p>
                </div>
              </td>
              <td className="text-white text-end md:text-left py-[16px] text-[14px] aeonik_normal">
                {m.code}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <a
        href=""
        className="flex items-start pl-[16px] md:pl-[24px] text-[16px] md:text-[18px] leading-[27px] text-white aeonik_medium"
      >
        <span className="mr-[4px]">{translation.SeeAll}</span>
        <img
          src={seearrow}
          alt="see"
          className="h-[20px] w-auto object-contain  transform rotate-90"
        />
      </a>

      {/* KYC From */}

      {
        Identity && (
          <div className=" bg-black/85 fixed top-0 right-0 left-0 bottom-0 z-50">
            <div className="bg-[#222222] px-[32px] xl:pb-[32px] xl:pt-[41px]  max-w-[520px]  max-h-[500px] overflow-auto xl:max-h-[750px] xl:overflow-visible fixed rounded-[24px] top-[50%] left-[50%] transform translate-x-[-50%] translate-y-[-50%]">
              <div className=" py-[10px] w-full bg-[#222222]  sticky top-[-5px] left-0 z-50 xl:hidden"></div>
              <div className=" flex items-center justify-between">
                <p className="text-[32px] text-white aeonik_normal">
                  {translation.Verifyyouridentity}
                </p>
                <img
                  src={cross}
                  alt="cross"
                  onClick={() => clearData()}
                  className=" cursor-pointer"
                ></img>
              </div>
              <p className="text-white aeonik_normal pt-[24px] pb-[32px] w-[90%]">
                {translation.identitydesc}
              </p>
              <form onSubmit={onSubmitKyc} className=" z-10">
                <div className="grid grid-cols-12 gap-x-[16px]">
                  <div className=" col-span-6 flex flex-col">
                    <label className=" text-[#909090] aeonik_normal text-[16px]">
                      First name
                    </label>
                    <input
                      required
                      value={FirstName}
                      onChange={(e) =>
                        setFirstName(
                          e.target.value?.replace(/[^A-Za-z&. ]/g, "")
                            ?.trimStart()
                        )
                      }
                      className="text-white bg-[#1a1a1a] outline-none rounded-[8px] py-[16px] mt-[12px] placeholder:text-[#484848] pl-4 aeonik_normal"
                      placeholder="Enter first name"
                    ></input>
                  </div>
                  <div className=" col-span-6 flex flex-col">
                    <label className=" text-[#909090] aeonik_normal text-[16px]">
                      Last name
                    </label>
                    <input
                      required
                      value={LastName}
                      onChange={(e) =>
                        setLastName(
                          e.target.value?.replace(/[^A-Za-z&. ]/g, "")
                            ?.trimStart()
                        )
                      }
                      className="text-white bg-[#1a1a1a] outline-none rounded-[8px] py-[16px] mt-[12px] placeholder:text-[#484848] pl-4 aeonik_normal"
                      placeholder="Enter last name"
                    ></input>
                  </div>
                  <div className=" col-span-12 flex flex-col pt-[16px]">
                    <label className=" text-[#909090] aeonik_normal text-[16px]">
                      Date of birth
                    </label>
                    <div className="relative">
                      <DatePicker
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        viewMode="start time"
                        required
                        // dateFormat="MM/dd/YYYY"
                        placeHolder="MM/DD/YYYY"
                        name="start time"
                        autoComplete="off"
                        maxDate={new Date()}
                        className="text-white w-full outline-none bg-[#1a1a1a] rounded-[8px] py-[16px] mt-[12px] placeholder:text-[#484848] pl-[20px] aeonik_normal"
                      />
                      <svg
                        className="w-4 absolute  right-5 top-8  h-4 text-white "
                        aria-hidden="true"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
                      </svg>
                    </div>
                  </div>
                  <div className=" col-span-12 flex flex-col pt-[16px]">
                    <label className=" text-[#909090] aeonik_normal text-[16px]">
                      Nationality
                    </label>
                    <Select
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 0,
                        colors: {
                          ...theme.colors,
                          text: "#fff",
                          font: "#fff",
                          primary25: "#fff",
                          primary: "#fff",
                          neutral80: "#fff",
                          color: "#fff",
                        },
                      })}
                      required
                      styles={colourStyles}
                      className="mt-[12px] aeonik_normal"
                      placeholder="Select country"
                      options={options}
                    />
                  </div>
                  <div className=" col-span-12 flex flex-col pt-[16px]">
                    <label className=" text-[#909090] aeonik_normal text-[16px]">
                      Passport number
                    </label>
                    <input
                      required
                      value={PasspotNo}
                      onChange={(e) => {
                        setPassportNo(e.target.value?.toUpperCase()?.trimStart());
                      }}
                      className=" text-white bg-[#1a1a1a] outline-none rounded-[8px] py-[16px] mt-[12px] placeholder:text-[#484848] pl-[20px] aeonik_normal"
                      placeholder="Enter passport number"
                    ></input>
                  </div>
                </div>
                <div className="flex justify-center">
                  <button
                    type="submit"
                    className="mt-[32px]  bg-sky py-[12px] px-[24px] rounded-[150px] text-black aeonik_medium text-[18px]"
                  >
                    {translation.VerifyNow}
                  </button>
                </div>
              </form>
              <div className=" py-[10px] w-full bg-[#222222]  sticky bottom-[-5px] left-0 z-50 xl:hidden"></div>
            </div>
          </div>
        )
      }

      {/* Mint Modal */}

      {
        MintModel && (
          <MintModal
            setMintModel={setMintModel}
            closeMintModel={closeMintModel}
          />
        )
      }

      {/* Redeem Modal */}

      {
        RedeemModel && (
          <RedeemModal
            setRedeemModel={setRedeemModel}
            closeRedeemModel={closeRedeemModel}
          />
        )
      }
    </div >
  );
}

export default Overview;
